// extracted by mini-css-extract-plugin
export default {"component":"component--m2LEX","dark":"dark--gxthh","hideLast":"hideLast--l5l9k"};